/* tslint:disable */

declare var Object: any;
export interface LeaseArchiveInterface {
  "old_lease_id": number;
  "name"?: string;
  "start_date": Date;
  "end_date": Date;
  "status": string;
  "rent_amount": number;
  "frequency": string;
  "automatically_end"?: boolean;
  "property_id": number;
  "property_unit_id": number;
  "chart_of_account_id"?: number;
  "tax_percentage"?: number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class LeaseArchive implements LeaseArchiveInterface {
  "old_lease_id": number;
  "name": string;
  "start_date": Date;
  "end_date": Date;
  "status": string;
  "rent_amount": number;
  "frequency": string;
  "automatically_end": boolean;
  "property_id": number;
  "property_unit_id": number;
  "chart_of_account_id": number;
  "tax_percentage": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: LeaseArchiveInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LeaseArchive`.
   */
  public static getModelName() {
    return "LeaseArchive";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LeaseArchive for dynamic purposes.
  **/
  public static factory(data: LeaseArchiveInterface): LeaseArchive{
    return new LeaseArchive(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'LeaseArchive',
      plural: 'LeaseArchives',
      path: 'LeaseArchives',
      idName: 'id',
      properties: {
        "old_lease_id": {
          name: 'old_lease_id',
          type: 'number'
        },
        "name": {
          name: 'name',
          type: 'string'
        },
        "start_date": {
          name: 'start_date',
          type: 'Date'
        },
        "end_date": {
          name: 'end_date',
          type: 'Date'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "rent_amount": {
          name: 'rent_amount',
          type: 'number'
        },
        "frequency": {
          name: 'frequency',
          type: 'string'
        },
        "automatically_end": {
          name: 'automatically_end',
          type: 'boolean'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "tax_percentage": {
          name: 'tax_percentage',
          type: 'number',
          default: 0
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
